const runtimeUrl = document.currentScript.dataset.runtimeUrl;
let runtimePromise;
let runtimeReady = false;

function loadRuntime() {
  if (!runtimePromise) {
    runtimePromise = import(runtimeUrl).then(() => {
      runtimeReady = true;
    });
  }
  return runtimePromise;
}

const replaySelectors = [
  "[data-menu-button]",
  "[data-menu-close]",
  "[data-search]",
  "[data-search-close]",
  "[data-cart-open]",
  "[data-cart-close]",
  "[data-add-to-cart]",
  "[data-media-thumbnail]",
].join(",");

document.addEventListener(
  "click",
  async (event) => {
    if (runtimeReady || !event.target.closest(replaySelectors)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const target = event.target;
    await loadRuntime();
    target.click();
  },
  true,
);

document.addEventListener("keydown", loadRuntime, { once: true, capture: true });
document.addEventListener("touchstart", loadRuntime, { once: true, capture: true, passive: true });
document.addEventListener("pointerover", loadRuntime, { once: true, capture: true, passive: true });

if ("requestIdleCallback" in window) {
  window.requestIdleCallback(loadRuntime, { timeout: 1600 });
} else {
  window.setTimeout(loadRuntime, 900);
}
